var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.514,
    height: 19.6,
    viewBox: "0 0 20.514 19.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_12_",
    transform: "translate(-21.6 -23.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_15_",
    transform: "translate(21.879 29.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_16_",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_17_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    d: "M42.935,53.241v7.236a.336.336,0,0,1-.33.33H38.873a.336.336,0,0,1-.33-.33V53.749c0-1.777-.635-3-2.234-3a2.417,2.417,0,0,0-2.26,1.6,2.779,2.779,0,0,0-.152,1.066v7.058a.336.336,0,0,1-.33.33H29.86a.336.336,0,0,1-.33-.33c0-1.8.051-10.511,0-12.542a.336.336,0,0,1,.33-.33h3.732a.336.336,0,0,1,.33.33v1.549c0,.025-.025.025-.025.051h.025v-.051A4.382,4.382,0,0,1,37.882,47.3c2.894,0,5.052,1.9,5.052,5.941Zm-19.9,7.591h3.732a.336.336,0,0,0,.33-.33V47.935a.336.336,0,0,0-.33-.33H23.03a.336.336,0,0,0-.33.33V60.5A.355.355,0,0,0,23.03,60.832Z",
    transform: "translate(-22.7 -47.3)",
    fill: "#a5a4a4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13_",
    transform: "translate(21.6 23.4)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_14_",
    cx: 2.361,
    cy: 2.361,
    r: 2.361,
    transform: "translate(0)",
    fill: "#a5a4a4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.266f2ba5f75d193001c797fc214fc890.svg";
export { ForwardRef as ReactComponent };